import React from 'react';
import classNames from 'classnames';
import { useProductPageContext } from '../../hooks/useProductPageContext';
import RenderedLink from './RenderLink';
import { generateCategoryPageUrl } from '@/components/category/helpers';
import i18n from '@/settings/i18n';

const t = i18n.init('categories');

const Breadcrumb = () => {
  const { additionalInfo, product } = useProductPageContext();

  if (!additionalInfo.breadcrumb || additionalInfo.breadcrumb.length === 0) {
    return null;
  }

  const { breadcrumb } = additionalInfo;

  const productTitle = product?.title;

  const lastItem = breadcrumb[breadcrumb.length - 1];
  const link = generateCategoryPageUrl(lastItem.name, lastItem.pk);

  return (
    <>
      {/* Mobile */}
      <div className="flex items-center text-xs lg:hidden">
        <RenderedLink link={link} title={t(lastItem.name)} isMobile />
      </div>
      {/* Desktop */}
      <div className="hidden items-center gap-1 text-xs lg:flex">
        <div className="flex items-center gap-1">
          <RenderedLink link="/" title={t`Home`} />
          <span className="block text-gray-700/50">/</span>
        </div>
        {breadcrumb.map((c) => {
          const _link = generateCategoryPageUrl(c.name, c.pk);

          return (
            <div
              key={`${c.name}_${c.pk}`}
              className="group flex items-center gap-1"
            >
              <RenderedLink link={_link} title={t(c.name)} />
              <span
                className={classNames('block text-gray-700/50', {
                  'group-last:hidden': productTitle,
                })}
              >
                /
              </span>
            </div>
          );
        })}
        {productTitle && (
          <span className="max-w-[300px] truncate text-gray-700/100">
            {productTitle}
          </span>
        )}
      </div>
    </>
  );
};

export default React.memo(Breadcrumb);
